import Errored from '../Errored';
import PropTypes from 'prop-types';
import GS from '../../grafsync/grafsync';
import PrimaryButton from '../PrimaryButton';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import BasicReadField from '../BasicReadField';
import NameField from './NameField';
import { globalStyles as styles } from '../style/gstheme';
import TitledPanel from '../TitledPanel';
import { makeCancelable } from '../utils/utils';
import { MAX_FAMILYNAME_LENGTH, MAX_GIVENNAME_LENGTH } from '../utils/constants';

class MyDetails extends React.Component {

    constructor(props) {
        super(props);
        const { username, givenName, familyName, email, id } = this.props.user;
        this.state = {
            username,
            givenName,
            familyName,
            email,
            id,
            isDirty: false,
            isErrored: false
        };
        this.cancellable = null;
    }

    onUpdate = (property) => (value) => this.setState({ [property]: value, isDirty: true });

    doUpdateUser(userID, payload) {
        this.cancellable = makeCancelable(GS.updateUser(userID, payload));
        return this.cancellable;
    }

    saveUpdates = async () => {
        try {
            const { givenName, familyName } = this.state;
            await this.doUpdateUser(this.props.user.id, {
                givenName,
                familyName
            }).promise;
            this.props.updateUser({
                givenName,
                familyName
            });
            this.setState({ isDirty: false });
        }
        catch (e) {
            if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) this.setState({
                isErrored: {
                    message: "Cannot update user details at the moment."
                }
            });
        }
    };

    render() {

        const { username, givenName, familyName, email, isDirty, id, isErrored } = this.state;

        if (isErrored) return <Errored dataTest="user-error" data={isErrored} />;

        return (
            <form autoComplete="off">
                <Grid container spacing={2} classes={
                    {
                        "spacing-xs-2": this.props.classes.fullGrid
                    }
                }>
                    <Grid item xs={12}>
                        <TitledPanel height="full" title="Username">
                            <BasicReadField ariaLabel="Username" dataTest="username" fullWidth text={username} locked />
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12}>
                        <TitledPanel height="full" title="IRI">
                            <BasicReadField ariaLabel="User IRI" dataTest="iri" fullWidth text={id} locked />
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12}>
                        <TitledPanel title="Given Name" height="full">
                            {this.props.ssoUser ?
                                <BasicReadField ariaLabel="Given name" dataTest="given-name-field" fullWidth text={givenName} locked />
                                :
                                <NameField
                                    ariaLabel="Given name"
                                    dataTest="given-name"
                                    autoComplete="given-name"
                                    fullWidth
                                    isMandatory={false}
                                    maxLength={MAX_GIVENNAME_LENGTH}
                                    text={givenName || ""}
                                    onUpdate={this.onUpdate("givenName")} />
                            }
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12}>
                        <TitledPanel title="Family Name" height="full">
                            {this.props.ssoUser ?
                                <BasicReadField ariaLabel="Family name" dataTest="family-name-field" fullWidth text={familyName} locked />
                                :
                                <NameField
                                    ariaLabel="Family name"
                                    dataTest="family-name"
                                    autoComplete="family-name"
                                    fullWidth
                                    isMandatory={false}
                                    maxLength={MAX_FAMILYNAME_LENGTH}
                                    text={familyName || ""}
                                    onUpdate={this.onUpdate("familyName")} />
                            }
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12}>
                        <TitledPanel title="Email" height="full">
                            <BasicReadField ariaLabel="Email" dataTest="email-field" fullWidth text={email || ""} locked />
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12}>
                        <div style={{ float: 'right' }}>
                            <PrimaryButton
                                dataTest="save"
                                disabled={!isDirty || this.props.ssoUser}
                                onClick={this.saveUpdates}>Save</PrimaryButton>
                        </div>
                    </Grid>
                </Grid>
            </form>
        );
    }
}

MyDetails.defaultProps = {
    ssoUser: false
};

MyDetails.propTypes = {
    classes: PropTypes.object,
    user: PropTypes.object.isRequired,
    updateUser: PropTypes.func.isRequired,
    ssoUser: PropTypes.bool
};

export default withStyles(styles)(MyDetails);